//上传上位机应用
import { Component, Prop } from 'vue-property-decorator';
import { createNamespace } from 'src/util/bem';
import Modal from 'src/types/iview/Modal';
import Button from 'src/types/iview/Button';
import { modalFactory } from 'src/util/vueExtend';
import * as Vue from 'vue-tsx-support';
import { Integer, IViewDate } from 'src/types/base';
import EnumUppercomputerType from 'src/enums/enumUppercomputerType';
import EntitySelect from 'src/components/SelectCustom/entitySelect';
import EnumEntity from 'src/enums/enumEntity';
import { type } from 'os';
import CommonSelect from 'src/components/SelectCustom/commonSelect';
import EnumAccessLevel from 'src/enums/enumAccessLevel';
import { LoginDOI } from 'src/pages/login/loginApi';
import LocalStore from 'src/util/LocalStore';
import { Toast } from 'src/util/toast';
import Upload from 'src/types/iview/Upload';
import Input from 'src/types/iview/Input';
import ApplicationMarketApi, {ApplicationMarketDOI} from './api/applicationMarketApi';
import ApplicationMarket from './applicationMarket';

export namespace ApplicationMarketVOI {
    export interface PropsI {
        operate: string;
        id?: number;
        saveSuccess?(): void;
        cancel?(): void;
    }
    export interface FormDataI {
        id?: Integer;
        file_name: string;  //文件名称
        data_url: string;  //文件存储路径\
        file_version: string; //上位机版本
        file_describe:string; //上位机描述
        type: Integer; //上位机类型
    }
}


@Component
class ApplicationMarketModal extends Vue.Component<ApplicationMarketVOI.PropsI> {
    @Prop({
        type: Function,
    })
    cancel!: () => void;

    @Prop({
        type: Function,
    })
    saveSuccess!: () => void;

    visible: boolean = false;

    loading: boolean = false;

    uploading: boolean = false;

    formData: ApplicationMarketVOI.FormDataI = {
        file_name: '',
        data_url: '',
        file_version:'',
        file_describe:'',
        type: null,
    };

    get headers() {
        let headers:any = {}
        let userInfo: LoginDOI.LoginResultI = LocalStore.getData('userInfo');
        headers.access_token = userInfo.access_token || '';
        headers.OperationPlatform = 'Web';
        return headers
    }

    close() {
        this.cancel && this.cancel();
        this.closeModal();
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }

    uploadSuccess(res) {
        Toast.success(res.message)
        this.uploading = false;
        if(res.code===0) {
            this.formData.data_url=res.data.url;
            this.formData.file_name = res.data.name;
        } 
    }
    
    render(h) {
        return (
            <Modal
                class={createNamespace('modal')}
                title={'上传资料'}
                width="900"
                v-model={this.visible}
                mask-closable={false}
                on-on-cancel={this.close}
            >   
               <i-form class={createNamespace('mt20')} ref="formValidate" labelWidth={100} model={this.formData} rules={this.rules}>
                    <form-item label="上位机描述" prop="file_describe" style="display: inline-block;width:45%">
                        <Input  placeholder="请输入" v-model={this.formData.file_describe} />
                    </form-item>
                    <form-item label="上位机版本" prop="file_version" style="display: inline-block;width:45%">
                        <Input  placeholder="请输入" v-model={this.formData.file_version} />
                    </form-item>
                    <form-item label="上位机类型" prop="type" style="display: inline-block;width:45%" required type="number">
                        <CommonSelect dataSource={EnumUppercomputerType.getList() as any} v-model={this.formData.type} placeholder="请输入" />
                    </form-item>
                    <form-item label="上传附件"  style="display: inline-block;width:90%">
                        <Upload
                            class="lims-file-upload"
                            action="/ops/files/upload"
                            show-upload-list={false}
                            name="accessory"
                            headers={this.headers}
                            on-success={this.uploadSuccess}
                            before-upload={() => {
                                this.uploading = true;
                            }}
                        >
                                <Button class={createNamespace('upload-btn')} icon="ios-cloud-upload-outline" loading={this.uploading}>上传附件</Button>
                        </Upload>
                        <div class={createNamespace('upload-text')}>支持扩展名：.rar .zip .doc .docx .pdf .jpg</div>
                    </form-item>
               </i-form>
                <div slot="footer">
                    <Button type="primary" ghost on-click={this.close}>
                        取消
                    </Button>
                    <Button type="primary" on-click={this.save} loading={this.loading}>
                        保存
                    </Button>
                </div>
            </Modal>
        );
    }

    async save(){
        if (!(await this.$validate('formValidate'))) {
            return;
        }
        this.loading = true;
        let params: ApplicationMarketDOI.AddData = {
            ...this.formData
        };
        let { code } = await ApplicationMarketApi.add(params);
        
        this.loading = false;
        if (code === 0) {
            Toast.success('上传成功');
            this.saveSuccess();
            this.closeModal();
        }
    }
}

export default function alertApplicationMarketApiModal(): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<ApplicationMarketVOI.PropsI>(ApplicationMarketModal)({
            saveSuccess() {
                resolve(true);
            },
            cancel() {
                resolve(false);
            },
        });
    });
}